// @flow

/**
 * Add two numbers.
 * @param {number} numA - The first number.
 * @param {number} numB - The other number.
 * @return {nmuber} return numA + numB.
 */
const add = (numA: number, numB: number): number => {
  return numA + numB
}

export default { add }
